import { QFilterGeneric } from './QFilterGeneric'

export class QFilterCentro extends QFilterGeneric {
  name = "centro";
  class_name = "QFilterCentro";
  api_name = null;
  
}
